
<div class="user-groups-dialog">
    <form #mapForm="ngForm" autocomplete="off">
        <mat-form-field class="fullWidth">
            <mat-label>Name</mat-label>
            <input matInput required [(ngModel)]="allData.selectedItem.name" name="name">
            <mat-error>
                Name is <strong>required</strong>
            </mat-error>
        </mat-form-field>

      <ac-input-container label="Dialable" [required]="true" class="dialable-container">
        <ac-select
          [(acModel)]="allData.selectedItem.associatedDialable"
          [items]="allData.dialableAttributes"
          [allowClear]="false"
          [multiple]="false">
        </ac-select>
      </ac-input-container>

        <mat-tab-group animationDuration="0" class="user-groups-tabs" (selectedTabChange)="onSelectedTabChange($event) ">
            <mat-tab label="PROPERTIES">
                <div class="properties">
                    <div class="properties-list">
                        <div class="property-item" *ngFor="let item of allData.selectedItem.conditions; let index = index;">
                            <i class="fa fa-times remove-item" (click)="removeCondition(index)"></i>
                            <div class="properties-selections">

                              <ac-input-container label="Property Dictionary Attribute"  >
                                <ac-select
                                  [(acModel)]="item.dicAttrName"
                                  [items]="allData.attributes"
                                  [allowClear]="false"
                                  [multiple]="false"
                                  [bindValue]="'name'"
                                  [bindLabel]="'name'" >
                                </ac-select>
                              </ac-input-container>

                              <ac-input-container label="Operator"  >
                                <ac-select
                                  [(acModel)]="item.operator"
                                  [items]="operatorsOptions"
                                  [allowClear]="false"
                                  [multiple]="false"
                                  [bindValue]="'id'"
                                  [bindLabel]="'name'" >
                                </ac-select>
                              </ac-input-container>


                            </div>
                            <mat-form-field class="attribute-values-input">
                                <mat-chip-list #chipList >
                                    <mat-chip    *ngFor="let value of item.values; let i = index"
                                              [selectable]="false"
                                              [removable]="true"
                                              (removed)="item.values.splice(i, 1)">
                                        <div class="attribute-chips" title="{{value}}">{{value}}</div>
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip>
                                    <input [matChipInputFor]="chipList"
                                           placeholder="Enter values here"
                                           [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                           [matChipInputAddOnBlur]="false"
                                           (matChipInputTokenEnd)="addValue($event, item.values)"
                                           (blur)="onOutOfFocus($event, item.values)">
                                </mat-chip-list>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="properties-actions">
                        <button (click)="addCondition()" cy-data="add" mat-icon-button matTooltip="Add">
                            <mat-icon [svgIcon]="'add'" class="icon-display"></mat-icon>
                        </button>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="USERS">
                <div class="users">
                    <arm-search [searchComponent]="usersSearchComponent"
                                [searchData]="searchData"
                                [searchTerms]="searchTerms"
                                (onSearch)="onSearch($event)">
                    </arm-search>

                    <div class="users-table">
                      <div *ngIf="!dataLoaded">
                        <inner-loader></inner-loader>
                      </div>
                        <arm-table [displayedColumns]="displayedColumns" [data]="tableData"
                                   [isCursorPageTable]="true" [isPagedTable]="false"
                                   (pageChangedCursor)="pageChanged($event)"
                                   [pageEventCursor]="pageEventCursor"></arm-table>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </form>
</div>

